var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-button',{attrs:{"variant":"primary","text":_vm.text,"disabled":_vm.disabled,"block":_vm.block,"type":_vm.type},on:{"click":function($event){return _vm.$emit(_vm.appConstants.app.emitEvents.CLICK, $event)}}},[_vm._t("default",function(){return [[_vm._v(_vm._s(_vm.text))]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }